import { Col, Row } from 'antd'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import PayItemSelect from 'components/CIMSSelect/common/PayItemSelect'
import { HelpMessage } from 'utils/constants'
import { AdditionalInfoBodyProps } from './types'
import CustomFieldEditor from 'components/CustomFields/CustomFieldEditor'
const help = HelpMessage.DesignSubmittals.Log

const AdditionalInfoBody: React.FC<AdditionalInfoBodyProps> = ({
  actionsOptions,
  disciplinesOptions,
  fdcOptions,
}) => {
  return (
    <>
      <Row>
        <Col xs={24}>
          <CIMSFormItem name="actionIds" label="Action(s)" help={help.Actions}>
            <CIMSSelect simple multiple options={actionsOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="disciplineIds"
            label="Discipline(s)"
            help={help.Disciplines}
          >
            <CIMSSelect simple multiple options={disciplinesOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="payItemIds"
            label="Pay Item(s)"
            help={help.PayItems}
          >
            <PayItemSelect multiple />
          </CIMSFormItem>
        </Col>
      </Row>
      <Row>
        <Col xs={24}>
          <CIMSFormItem
            name="fdcIds"
            label="Field Design Change(s)"
            help={help.FDCs}
          >
            <CIMSSelect multiple options={fdcOptions} />
          </CIMSFormItem>
        </Col>
      </Row>
      <CustomFieldEditor alreadyDisabled={false} />
    </>
  )
}

export default AdditionalInfoBody
